import { useRef } from "react";
import { createInput, getCreationInput } from "../misc/helperfuncs";

const getInputs = (type, inputObject, extras, boxType) => {
  const inputs = [
    getCreationInput(
      "input",
      "Short Description",
      "shortDescription",
      boxType.descriptions.shortDescription,
      true,
      {
        maxLength: 100,
        minLength: 4,
        value: inputObject.shortDescription,
        inputType: "text",
        fixed: extras?.fixed,
        allowSpaces: true,
      },
      "string"
    ),
    getCreationInput(
      "keywords",
      "Keywords",
      "keywords",
      boxType.descriptions.keywords,
      true,
      {
        minLength: 2,
        maxLength: 5,
        keywords: inputObject.keywords,
      },
      "array"
    ),
    getCreationInput(
      "pickList",
      "Categories",
      "categories",
      boxType.descriptions.categories,
      true,
      {
        type: inputObject.type,
        selectedItems: inputObject.categories,
        minLength: 1,
        maxLength: 5,
      },
      "array"
    ),
    getCreationInput(
      "pickList",
      "Things",
      "things",
      boxType.descriptions.things,
      false,
      {
        type: inputObject.type,
        selectedItems: inputObject.things,
        minLength: 0,
        maxLength: 10,
      }
    ),
  ];

  if (
    ["goal", "task", "vice", "leasure", "routine", "problem"].includes(
      inputObject.type
    )
  ) {
    inputs.push(
      getCreationInput(
        "input",
        "Long Description",
        "longDescription",
        boxType.descriptions.longDescription,
        false,
        {
          maxLength: 300,
          minLength: 4,
          value: inputObject.longDescription,
          inputType: "text",
          fixed: extras?.fixed?.longDescription,
          allowSpaces: true,
        }
      )
    );
    inputs.push(
      getCreationInput(
        "image",
        "Image",
        "image",
        boxType.descriptions.image,
        false,
        {
          image: inputObject.image,
        }
      )
    );
    inputs.push(
      getCreationInput(
        "ratingBar",
        boxType.ratings.general.first.general.name,
        "first",
        boxType.ratings.general.first.general.hint,
        false,
        {
          place: "first",
          rating: inputObject?.ratings.first.rating,
          icon: boxType.ratings.general.first.general.icon,
        }
      )
    );
    inputs.push(
      getCreationInput(
        "ratingBar",
        boxType.ratings.general.second.general.name,
        "second",
        boxType.ratings.general.second.general.hint,
        false,
        {
          place: "second",
          rating: inputObject?.ratings.second.rating,
          icon: boxType.ratings.general.second.general.icon,
        }
      )
    );
  }

  boxType.related.types.forEach((r) => {
    inputs.push(
      getCreationInput(
        "pickRelated",
        `Related ${r}`,
        r,
        boxType.descriptions[r],
        false,
        {
          type: "pickRelated",
          types: [r],
          field: r,
          selectedObjects: inputObject[r],
        }
      )
    );
  });
  if (boxType.time) {
    inputs.push(
      getCreationInput("time", "Time", "time", boxType.time, false, {
        timeValue: inputObject.time,
      })
    );
  }

  return inputs;
};

export { getInputs };
